export const stepTitles = [
  {
    title: "已安排",
    type: "arrange",
  },
  {
    title: "抵達社區",
    type: "arrivalCommunity",
  },
  {
    title: "已上車",
    type: "onBoard",
  },
  {
    title: "抵達目的地",
    type: "arrivalDestination",
  },
];
